// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import {
  executePolling,
  getResponseCheckDefaultAction,
  REQUEST_STATUS_COMPLETED,
  REQUEST_STATUS_FAILED
} from '../../../../share/util/api/polling';
import { apiErrorDefaultAction } from '../../../../share/util/api/errorAction';
import apiService from '../../../../share/util/api/service';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';
import util from "../../../../share/util/utils";
import dataMonitor from "../../../vue/dataMonitor/DataMonitor";
import logWrapper from '../../../../share/logWrapper';
import noTextSVGButton, { ICON_KEY, BUTTON_TYPE } from "../../../../share/components/vue/NoTextSVGButton";
import dmUtil from "../../dataMonitor/dataMonitorUtil";

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  OFF_WAIT: 'offWait',
  ORDER_OFF: 'orderOff',
  ORDER_ON: 'orderOn',
  ORDER_INSPECTION: 'orderInspection',
  ORDER_TEMPERATURE: 'orderTemperature',
  ORDER_SELECT_P: 'orderSelectP',
  ORDER_IG_SW_OFF_ON: 'orderIgSwOffOn',
  RUN_ORDER: 'runOrder',
  RUN_WAIT: 'runWait',
  STOP_ORDER: 'stopOrder',
  COMMUNICATION_ERROR: 'communicationError',
  TIME_OVER: 'timeOver',
  CONNECT_FAILED: 'connectionFailed',
};

const ERROR_CHECK_INTERVAL = 1000;

export default {
  name: 'requirement022',
  data() {
    return {
      phase: PHASE.START,
      modalSize: 'lg',
      isLoading: false,
      // 画面表示メッセージ用
      displayMsg: '',
      // 温度異常時のメッセージ用
      temperatureMsg: '',
      // 読み込み中フラグ ボタン非活性等で使用
      isCanceled: false,
      systemId: '',
      waitTime: 0,
      requestId: '',
      isFirst: true,
      // ダイアログフラグ
      modal_work_support_022: false,
      isReload: false, // データ読出し再実行判定用フラグ
      /* データモニタ用 */
      isUseCache: true, // システム間移動判定（同一システムの場合、falseを指定することで初期化通信を省略することが可能）
      inExecution: true, // ECU計測中フラグ(WS.22では最初から計測中とする)
      checkLines: 0,  // グラフ項目件数
      inspectionTargetDid: "",
      inspectionTargetDidData: "",
      // 監視中モーダル表示
      isRunWait: false,
      dataMonitorFunctionSettings: new dmUtil.DataMonitorFunctionSettings(dmUtil.TYPE_CALLER.WS22), // DM機能の設定インスタンス
      ICON_KEY: ICON_KEY, // SVGアイコンの種類
      BUTTON_TYPE: BUTTON_TYPE, // SVGアイコンのボタンの種類
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    "data-monitor": dataMonitor,
    "no-text-svg-button": noTextSVGButton,
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: (state) => state.vehicle.vehicleInfo,
    }),
    btnDisabled() {
      const disabled = {
        graph: !this.checkLines
      };
      return disabled;
    },
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.START:
          return 'warning';
        case PHASE.CONNECT_FAILED:
        case PHASE.COMMUNICATION_ERROR:
        case PHASE.TIME_OVER:
          return 'danger';
        case PHASE.OFF_WAIT:
        case PHASE.ORDER_OFF:
        case PHASE.ORDER_ON:
        case PHASE.ORDER_INSPECTION:
        case PHASE.ORDER_TEMPERATURE:
        case PHASE.ORDER_SELECT_P:
        case PHASE.ORDER_IG_SW_OFF_ON:
        case PHASE.RUN_ORDER:
        case PHASE.STOP_ORDER:
        default:
          return 'secondary';
      }
    },
  },

  watch: {
    async phase(value) {
      switch (value) {
        case PHASE.RUN_ORDER:
          this.isRunWait = false;
          this.modalSize = 'huge';
          break;
        case PHASE.RUN_WAIT:
          this.isRunWait = true;
          this.modalSize = 'huge';
          break;
        default:
          this.isRunWait = false;
          this.modalSize = 'lg';
          break;
      }
    },
    /**
     * データモニタ側の計測中フラグを監視し、変更時に実行。
     * 停止時にデータモニタ側でエラーが発生している場合は、エラーダイアログが閉じられるまで待機し、その後、汎用エラーを表示する。
     * @param {boolean} value - ECU計測中フラグの新しい値
     */
    async inExecution(value) {
      if (!value && this.$refs?.data_monitor?.isError) {
        while (this.$refs?.data_monitor?.isError) {
          await util.sleep(ERROR_CHECK_INTERVAL);
        }
        this.showUnexpectedError();
      }
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.modal_work_support_022 = true;
    },

    /** Wizardを閉じる */
    closeWizard() {
      this.isRunWait = false;
      this.$emit('close-wizard');
      this.modal_work_support_022 = false;
    },

    /** 中止表示ボタンクリック処理 */
    clickShowStop() {
      // キャンセルボタンを活性化させる
      this.isCanceled = false;
      this.phase = PHASE.STOP_ORDER;
    },

    /** エンジン動作検出OKボタンクリック処理 */
    async clickReEngine() {
      await this.executeIgSwOffOn();
    },

    /** 駆動ボタンクリック処理 */
    async clickDrive() {
      // 書込み処理へ遷移
      await this.executeWrite();
    },

    /** EOP通信エラー処理 */
    showEopError() {
      this.isLoading = false;
      this.phase = PHASE.COMMUNICATION_ERROR;
    },

    /** データモニタ状態切替（計測開始/停止状態） */
    toggleExecute(flg) {
      if (flg === undefined || flg === null) {
        this.inExecution = !this.inExecution;
      } else {
        this.inExecution = flg;
      }
    },

    /** DataMonitorコンポーネントで項目選択画面に戻る処理が走った場合 */
    toggleShowSelect(flg) {
      if (flg === true) {
        this.showUnexpectedError();
      }
    },

    /** モニタ停止 */
    async stopMonitor() {
      await this.$refs.data_monitor.stopMonitor();
    },

    /** モニタ停止(errorTerminateで停止) */
    async stopMonitorErrorTerminate() {
      await this.$refs.data_monitor.stopMonitorErrorTerminate();
    },

    /** グラフ項目件数を変更 */
    changeCheckValue(checkLines) {
      this.checkLines = checkLines;
    },

    /** グラフ設定ダイアログを開く */
    handleConfigureGraph() {
      this.$refs.data_monitor.handleConfigureGraph();
    },

    /** データ読み出し処理(IGOFF指示) */
    async executeIgOff() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read-igoff'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：res_typeの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // IGOFF維持へ遷移
                  this.phase = PHASE.OFF_WAIT;
                  // 指定時間計測
                  this.waitTime = response.data.user_data.wait_time;
                  await util.sleep(this.waitTime);
                  // IGON指示へ遷移
                  await this.executeIgOn();
                  break;
                default:
                  // キャンセルボタンを活性化する
                  this.isCanceled = false;
                  // IGOFF実施へ遷移
                  this.phase = PHASE.ORDER_OFF;
                  this.requestId = response.data.user_data.request_id;
                  await this.executeIgOffWait();
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /** データ読み出し処理(IGOFF実施) */
    async executeIgOffWait() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'readwait-igoff',
            request_id: this.requestId
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // 中止処理が発生していた場合は終了する
        if (this.isCanceled) {
          return;
        }

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：responseの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // キャンセルボタンを非活性化する
                  this.isCanceled = true;
                  // IGOFF維持へ遷移
                  this.phase = PHASE.OFF_WAIT;
                  // 指定時間計測
                  this.waitTime = response.data.user_data.wait_time;
                  await util.sleep(this.waitTime);
                  // IGON指示へ遷移
                  await this.executeIgOn();
                  break;
                default:
                  // タイムアウトエラーへ遷移
                  this.phase = PHASE.TIME_OVER;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        // タイムアウト時、または中止がされていない場合はスピナーを非表示
        if (!this.isCanceled) {
          this.isLoading = false;
        }
      }
    },

    /** データ読み出し処理(IGON指示) */
    async executeIgOn() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read-igon'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：res_typeの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // 仮故障コード確認フラグへ遷移
                  await this.executeDetected();
                  break;
                default:
                  // キャンセルボタンを活性化する
                  this.isCanceled = false;
                  // IGON実施へ遷移
                  this.phase = PHASE.ORDER_ON;
                  this.requestId = response.data.user_data.request_id;
                  await this.executeIgOnWait();
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し処理(IGON実施) */
    async executeIgOnWait() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'readwait-igon',
            request_id: this.requestId
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // 中止処理が発生していた場合は終了する
        if (this.isCanceled) {
          return;
        }

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：res_typeの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // キャンセルボタンを無効化する
                  this.isCanceled = true;
                  // 仮故障コード確認フラグへ遷移
                  await this.executeDetected();
                  break;
                default:
                  // タイムアウトエラーへ遷移
                  this.phase = PHASE.TIME_OVER;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し処理(仮故障コード確認フラグ) */
    async executeDetected() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read-inspection'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：res_typeの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // EOP 点検モード油温許可条件フラグへ遷移
                  await this.executeTemperature();
                  break;
                default:
                  // 故障検出表示へ遷移
                  this.phase = PHASE.ORDER_INSPECTION;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し処理(EOP 点検モード油温許可条件フラグ) */
    async executeTemperature() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read-temperature'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // 中止画面へ遷移していた場合、以降処理終了
        if (this.phase === PHASE.STOP_ORDER) {
          this.isLoading = false;
          return;
        }

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：res_typeの結果によって分岐
              this.unit = this.$t(`didUnit.${response.data.user_data.atf_temperature.unit}`);
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // Pレンジセレクト指示へ遷移
                  await this.executeSelectP();
                  break;
                default:
                  // キャンセルボタンを活性化する
                  this.isCanceled = false;
                  // 暖機・冷却運転指示へ遷移
                  this.phase = PHASE.ORDER_TEMPERATURE;
                  this.temperatureMsg = this.$t(`individual.label_order_temperature`, [response.data.user_data.atf_temperature.lower_limit, response.data.user_data.atf_temperature.upper_limit, response.data.user_data.atf_temperature.current_value]);
                  // VUE_APP_RETRY_INTERVALの時間分sleep
                  await util.sleep(process.env.VUE_APP_RETRY_INTERVAL);
                  // EOP 点検モード油温許可条件フラグ
                  await this.executeTemperature();
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し処理(Pレンジセレクト指示) */
    async executeSelectP() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read-select_p'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：res_typeの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // エンジン始動フラグへ遷移
                  await this.executeIgSwOffOn();
                  break;
                default:
                  // キャンセルボタンを活性化する
                  this.isCanceled = false;
                  // Pレンジセレクト実施へ遷移
                  this.phase = PHASE.ORDER_SELECT_P;
                  this.requestId = response.data.user_data.request_id;
                  await this.executeSelectPWait();
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し処理(Pレンジセレクト実施) */
    async executeSelectPWait() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'readwait-select_p',
            request_id: this.requestId
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // 中止処理が発生していた場合は終了する
        if (this.isCanceled) {
          return;
        }

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：res_typeの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // キャンセルボタンを無効化する
                  this.isCanceled = true;
                  // エンジン始動フラグの取得へ遷移
                  await this.executeIgSwOffOn();
                  break;
                default:
                  // タイムアウトエラーへ遷移
                  this.phase = PHASE.TIME_OVER;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し処理(エンジン始動フラグ) */
    async executeIgSwOffOn() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read-ig_sw_off_on'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：res_typeの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // NonDefaultSession遷移
                  await this.executeNonDefaultSession();
                  break;
                default:
                  // エンジン動作検出へ遷移
                  this.phase = PHASE.ORDER_IG_SW_OFF_ON;
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** NonDefaultSession遷移・セキュリティアクセス処理 */
    async executeNonDefaultSession() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'pre_execute'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // dmatでデータ読出し/書き込みするDID、および書き込み時のdata_recordを保持
              this.inspectionTargetDid = response.data.user_data.did;
              this.inspectionTargetDidData = response.data.user_data.data_record;
              // 作業サポート機能はいったん停止
              await this.closeWorkSupport();
              // 実行へ遷移
              this.phase = PHASE.RUN_ORDER;
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 共通エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ書込み処理(実行) */
    async executeWrite() {
      try {
        // 以降、作業サポート機能のAPIを利用する場合は初回扱い
        this.isFirst = true;

        this.isLoading = true;
        const token = session.getToken();
        const response = await executePolling(
          this,
          // 呼び出したい POST API を実装
          async () => {
            const ret = await apiService.postCall(
              apiService.DMAT,
              `/netApps/${this.netAppId}/systems/${this.systemId}/workSupports/${this.workSupportId}`,
              {
                id_token: token.id_token,
                did: this.inspectionTargetDid,
                data_record: this.inspectionTargetDidData,
                type: 'write'
              }
            );
            return ret;
          },
          // 呼び出したい GET API を実装
          async (postApiResponse) => {
            return await apiService.getCall(
              apiService.DMAT,
              `/netApps/${this.netAppId}/systems/${this.systemId}/workSupports/${this.workSupportId}/requests/${postApiResponse?.data?.request_id}`
            );
          },
          // エラー発生のコールバック
          async (errorType) => {
            errorType;
            await this.stopMonitorErrorTerminate();
            this.showUnexpectedError();
          },
          // POST API レスポンスチェックのコールバックはデフォルト処理を使用
          undefined,
          // GET API レスポンスチェックのコールバックの処理を実装（"failed" が返ってきた場合に無視するため）
          (getApiResponse) => {
            if (getApiResponse?.data?.status === REQUEST_STATUS_FAILED) {
              logWrapper.log(
                "receive failed response. continue.",
                getApiResponse?.data,
                true
              );
              return REQUEST_STATUS_COMPLETED;
            }
            return getResponseCheckDefaultAction(getApiResponse);
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // ポーリング時のタイムアウト停止コールバック関数デフォルト処理を使用
          undefined,
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
          process.env.VUE_APP_WORK_SUPPORT_RETRY_COUNT,
          process.env.VUE_APP_WORK_SUPPORT_RETRY_INTERVAL
        );
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：点検準備へ遷移
              this.displayMsg = this.$t(`individual.label_wait_preparation`);
              // 実行監視モーダル表示
              this.phase = PHASE.RUN_WAIT;
              await this.executeInspectionPreparation();
              break;
            case REQUEST_STATUS_FAILED:
              // データモニタ停止
              await this.stopMonitorErrorTerminate();
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、データモニタ停止 → 汎用エラー
              await this.stopMonitorErrorTerminate();
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し処理(点検準備) */
    async executeInspectionPreparation() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await executePolling(
          this,
          // 呼び出したい POST API を実装
          async () => {
            const ret = await apiService.postCall(
              apiService.DMAT,
              `/netApps/${this.netAppId}/systems/${this.systemId}/workSupports/${this.workSupportId}`,
              {
                id_token: token.id_token,
                did: [this.inspectionTargetDid],
                type: 'read'
              }
            );
            return ret;
          },
          // 呼び出したい GET API を実装
          async (postApiResponse) => {
            return await apiService.getCall(
              apiService.DMAT,
              `/netApps/${this.netAppId}/systems/${this.systemId}/workSupports/${this.workSupportId}/requests/${postApiResponse?.data?.request_id}`
            );
          },
          // エラー発生のコールバック
          async (errorType) => {
            errorType;
            // データモニタ停止
            await this.stopMonitorErrorTerminate();
            this.showUnexpectedError();
          },
          // POST API レスポンスチェックのコールバックはデフォルト処理を使用
          undefined,
          // GET API レスポンスチェックのコールバックの処理を実装（"failed" が返ってきた場合に無視するため）
          (getApiResponse) => {
            if (getApiResponse?.data?.status === REQUEST_STATUS_FAILED) {
              logWrapper.log(
                "receive failed response. continue.",
                getApiResponse?.data,
                true
              );
              return REQUEST_STATUS_COMPLETED;
            }
            return getResponseCheckDefaultAction(getApiResponse);
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // ポーリング時のタイムアウト停止コールバック関数デフォルト処理を使用
          undefined,
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
          process.env.VUE_APP_WORK_SUPPORT_RETRY_COUNT,
          process.env.VUE_APP_WORK_SUPPORT_RETRY_INTERVAL
        );
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED: {
              // 正常終了：resultの結果によって分岐
              const result = response.data.user_data[0].value.slice(-2);
              switch (result) {
                case 'A1':
                  // 点検準備を実施
                  await this.executeInspectionPreparation();
                  break;
                case 'A2':
                  // 点検中へ遷移
                  this.displayMsg = this.$t(`individual.label_wait_inspection`);
                  await this.executeInspection();
                  break;
                default:
                  // 点検完了(DefaultSession)へ遷移
                  // 点検準備で読み出したDIDの内容に応じて表示する文言を設定
                  // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                  /* eslint-disable max-depth */
                  if (!(this.$te(`individual.result_eop_0x${result}`))) {
                    this.displayMsg = this.$t(`individual.result_eop_other`);
                  } else {
                    this.displayMsg = this.$t(`individual.result_eop_0x${result}`);
                  }
                  // データモニタ停止
                  await this.stopMonitor();
                  await this.executeInspectionComplete();
                  break;
              }
              break;
            }
            case REQUEST_STATUS_FAILED:
              // データモニタ停止
              await this.stopMonitorErrorTerminate();
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、データモニタ停止 → 汎用エラー
              await this.stopMonitorErrorTerminate();
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し処理(点検中) */
    async executeInspection() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await executePolling(
          this,
          // 呼び出したい POST API を実装
          async () => {
            const ret = await apiService.postCall(
              apiService.DMAT,
              `/netApps/${this.netAppId}/systems/${this.systemId}/workSupports/${this.workSupportId}`,
              {
                id_token: token.id_token,
                did: [this.inspectionTargetDid],
                type: 'read'
              }
            );
            return ret;
          },
          // 呼び出したい GET API を実装
          async (postApiResponse) => {
            return await apiService.getCall(
              apiService.DMAT,
              `/netApps/${this.netAppId}/systems/${this.systemId}/workSupports/${this.workSupportId}/requests/${postApiResponse?.data?.request_id}`
            );
          },
          // エラー発生のコールバック
          async (errorType) => {
            errorType;
            // データモニタ停止
            await this.stopMonitorErrorTerminate();
            this.showUnexpectedError();
          },
          // POST API レスポンスチェックのコールバックはデフォルト処理を使用
          undefined,
          // GET API レスポンスチェックのコールバックの処理を実装（"failed" が返ってきた場合に無視するため）
          (getApiResponse) => {
            if (getApiResponse?.data?.status === REQUEST_STATUS_FAILED) {
              logWrapper.log(
                "receive failed response. continue.",
                getApiResponse?.data,
                true
              );
              return REQUEST_STATUS_COMPLETED;
            }
            return getResponseCheckDefaultAction(getApiResponse);
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // ポーリング時のタイムアウト停止コールバック関数デフォルト処理を使用
          undefined,
          // ポーリング間隔/回数は作業サポートのデフォルト設定を使用
          process.env.VUE_APP_WORK_SUPPORT_RETRY_COUNT,
          process.env.VUE_APP_WORK_SUPPORT_RETRY_INTERVAL
        );
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED: {
              // 正常終了：resultの結果によって分岐
              const result = response.data.user_data[0].value.slice(-2);
              switch (result) {
                // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                /* eslint-disable max-depth */
                case 'A2':
                  // 点検中を実施
                  await this.executeInspection();
                  break;
                default:
                  // DefaultSession(exit)へ遷移
                  // 点検準備で読み出したDIDの内容に応じて表示する文言を設定
                  if (!(this.$te(`individual.result_eop_0x${result}`))) {
                    this.displayMsg = this.$t(`individual.result_eop_other`);
                  } else {
                    this.displayMsg = this.$t(`individual.result_eop_0x${result}`);
                  }
                  // データモニタ停止
                  await this.stopMonitor();
                  await this.executeInspectionComplete();
                  break;
              }
              break;
            }
            case REQUEST_STATUS_FAILED:
              // データモニタ停止
              await this.stopMonitorErrorTerminate();
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、データモニタ停止 → 汎用エラー
              await this.stopMonitorErrorTerminate();
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** DefaultSession処理 */
    async exit() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'exit',
            is_first: this.isFirst
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // exit処理を行うのは点検完了前と中止確認の際に行う
        switch (this.phase) {
          // 点検準備/点検中からの要求であった場合
          case PHASE.RUN_WAIT:
            // 実行動作中のDefaultSessionは正常/異常に関わらず点検完了に遷移
            await this.executeInspectionComplete();
            break;
          case PHASE.STOP_ORDER:
            switch (response.data.status) {
              case REQUEST_STATUS_COMPLETED:
                // 正常終了：機能終了
                this.closeWizard();
                break;
              case REQUEST_STATUS_FAILED:
              default:
                // 異常終了：共通エラー
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // その他共通エラーの場合は正常異常関係なしに閉じる
            this.closeWizard();
            break;
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /** データ読出し処理(点検完了) */
    async executeInspectionComplete() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read-inspection_completed',
            is_reload: this.isReload
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了：resultの結果によって分岐
              switch (response.data.user_data.res_type) {
                case 'ok':
                  // IGOFF維持を実施
                  this.displayMsg = this.$t(`individual.label_wait_ig_sw_off`);
                  this.waitTime = response.data.user_data.wait_time;
                  await util.sleep(this.waitTime);
                  // 指定時間経過後、Close処理を実施
                  await this.closeWorkSupport();
                  this.closeWizard();
                  break;
                default:
                  // データの読出しを再度実行
                  this.isReload = true;
                  await this.executeInspectionComplete();
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了：通信エラー
              this.phase = PHASE.COMMUNICATION_ERROR;
              break;
            default:
              // 該当のエラーコードが存在しない場合、汎用エラー
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** Close処理 */
    async closeWorkSupport() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'close'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * データ読出し中止
     * @returns
     */
    async stopReadData() {
      try {
        this.isLoading = true;
        // キャンセルボタンを非活性化させる
        this.isCanceled = true;
        // 中止画面に遷移
        this.phase = PHASE.STOP_ORDER;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'readwait_stop',
            request_id: this.requestId
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );
      } finally {
        this.isLoading = false;
        this.isCanceled = false;
      }
    },

    //----- エラーメソッド -----------------------------------------------//

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result handler.validate で返ってきたバリデーション結果
    */
    validateErrorResult(result) {
      apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** 共通エラー処理 */
    async showUnexpectedError() {
      this.isLoading = false;
      this.phase = PHASE.CONNECT_FAILED;
    },
  },
};
